import { useSelector } from 'react-redux';

import { RootState } from 'reducers/rootReducer';
import { Language } from 'types/Language/Language';

export const useEntryLanguageCode = (id: string): string => {
	const reduxLanguages: Language[] = useSelector((state: RootState) => state.languages);
	const reduxAllowedEntryLanguages: string[] = useSelector(
		(state: RootState) => state.allowedEntryLanguages
	);

	const getDefaultCultureCode = (): string => {
		return reduxAllowedEntryLanguages[0] ?? '';
	};

	const getCultureCode = () => {
		const language: Language | undefined = reduxLanguages.find((x) => x.id === id);
		if (!language) return getDefaultCultureCode();
		if (!reduxAllowedEntryLanguages.includes(language.cultureCode))
			return getDefaultCultureCode();
		return language.cultureCode;
	};

	return getCultureCode();
};
